require('./toggleButton.tpl.html');
require('./toggleButtonController');

const ToggleButtonComponent = {
    templateUrl: '/ui/toggleButton/toggleButton.tpl.html',
    controller: 'umToggleButtonController',
    bindings: {
        className: '@',
        value: '<',
        isDisabled: '<',
        onChange: '&'
    }
};

angular.module('umCore')
    .component('umToggleButton', ToggleButtonComponent);
